<template>
  <SideBarAsideFix/>

  <div class="content pd-0" style="border: 1px solid #ccc;">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">
      <div class="container pd-x-0">

          <!-- Low balance banner -->
<!--          <div class="low-bal-banner" :class="{ show: lowBalance }">-->
<!--            <i class="fas fa-exclamation-triangle" style="font-size:16px;flex-shrink:0;"></i>-->
<!--            <div><strong>Low balance — 45 credits remaining.</strong> Recharge to keep your campaigns running.</div>-->
<!--            <a href="/sms/credits" class="btn btn-sm btn-warning mg-l-auto" style="white-space:nowrap;">Buy Credits →</a>-->
<!--          </div>-->

          <!-- ══ BLUE HERO PANEL ══════════════════════════════════════════ -->
          <div class="sms-hero">
            <!-- Header row -->
            <div class="d-flex align-items-start justify-content-between mg-b-4">
              <div>
                <div class="hero-breadcrumb">
                  <ol class="breadcrumb breadcrumb-style1">
                    <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                    <li class="breadcrumb-item active" aria-current="page">SMS Overview</li>
                  </ol>
                </div>
                <h4 class="hero-title">SMS Overview</h4>
              </div>
              <div class="hero-actions d-none d-md-flex">
                <button class="btn-hero-outline" @click="doRefresh">
                  <i class="fas fa-sync-alt" style="font-size:10px;margin-right:5px;"></i>Refresh
                </button>
                <button class="btn-hero-outline" @click="doExport">
                  <i class="fas fa-download" style="font-size:10px;margin-right:5px;"></i>Export
                </button>
                <a href="/sms/credits" class="btn-hero-primary">
                  <i class="fas fa-plus" style="font-size:10px;"></i> Buy Credits
                </a>
              </div>
            </div>

            <!-- KPI Strip -->
            <div class="hero-kpi-strip">
              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Credit Balance</div>
                <div class="hero-kpi-value">{{ kpi.credits }}</div>
                <div class="hero-kpi-sub">credits available</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.creditsUsedPercent + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-neu"><i class="fas fa-minus" style="font-size:8px;"></i> {{ kpi.creditsUsed }} used</div>
              </div>

              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Sent This Month</div>
                <div class="hero-kpi-value">{{ kpi.sentMonth }}</div>
                <div class="hero-kpi-sub">messages</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.sentMonthPercent + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-up"><i class="fas fa-arrow-up" style="font-size:8px;"></i> +8% vs last month</div>
              </div>

              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Delivery Rate</div>
                <div class="hero-kpi-value">{{ kpi.deliveryRate }}%</div>
                <div class="hero-kpi-sub">of sent messages</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.deliveryRate + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-up"><i class="fas fa-arrow-up" style="font-size:8px;"></i> +1.2% vs last month</div>
              </div>

              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Failed</div>
                <div class="hero-kpi-value">{{ kpi.failed }}</div>
                <div class="hero-kpi-sub">this month</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.failRate + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-down"><i class="fas fa-arrow-down" style="font-size:8px;"></i> {{ kpi.failRate }}% fail rate</div>
              </div>

              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Active Campaigns</div>
                <div class="hero-kpi-value">{{ kpi.activeCampaigns }}</div>
                <div class="hero-kpi-sub">{{ kpi.activeCampaignsSub }}</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.activeCampaignsPercent + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-up"><i class="fas fa-arrow-up" style="font-size:8px;"></i> 2 more than last month</div>
              </div>

              <div class="hero-kpi-item">
                <div class="hero-kpi-label">Avg Delivery</div>
                <div class="hero-kpi-value">{{ kpi.avgDelivery }}s</div>
                <div class="hero-kpi-sub">end-to-end</div>
                <div class="hero-kpi-bar-track"><div class="hero-kpi-bar-fill" :style="{ width: kpi.avgDeliveryPercent + '%' }"></div></div>
                <div class="hero-kpi-badge hbadge-up"><i class="fas fa-arrow-up" style="font-size:8px;"></i> 0.3s faster than avg</div>
              </div>
            </div>
          </div>
          <!-- ══ END HERO PANEL ══ -->

          <!-- ══ ROW 1: Quick actions ══ -->
          <div class="row row-xs mg-b-20">
            <div class="col-12">
              <div class="card">
                <div class="card-header pd-t-15 pd-b-15">
                  <h6 class="card-title">Quick Actions</h6>
                </div>
                <div class="card-body pd-15">
                  <div class="row row-xs">
                    <div class="col-6 col-sm-3 mg-b-10">
                      <a href="/sms/send" class="quick-action">
                        <div class="qa-icon" style="background:#eef3ff;"><i class="fas fa-paper-plane" style="color:#0168fa;"></i></div>
                        <div class="qa-label">Send Message</div>
                        <div class="qa-sub">Compose &amp; send now</div>
                      </a>
                    </div>
                    <div class="col-6 col-sm-3 mg-b-10">
                      <a href="/sms/campaing" class="quick-action" @click.prevent="newCampaign">
                        <div class="qa-icon" style="background:#f3f0ff;"><i class="fas fa-bullhorn" style="color:#7c3aed;"></i></div>
                        <div class="qa-label">New Campaign</div>
                        <div class="qa-sub">Bulk scheduled send</div>
                      </a>
                    </div>
                    <div class="col-6 col-sm-3 mg-b-10">
                      <a href="/sms/credits" class="quick-action">
                        <div class="qa-icon" style="background:#e6f9f2;"><i class="fas fa-coins" style="color:#10b981;"></i></div>
                        <div class="qa-label">Buy Credits</div>
                        <div class="qa-sub">{{ kpi.credits }} credits remaining</div>
                      </a>
                    </div>
                    <div class="col-6 col-sm-3 mg-b-10">
                      <a href="#" class="quick-action" @click.prevent="viewHistory">
                        <div class="qa-icon" style="background:#fefce8;"><i class="fas fa-history" style="color:#f59e0b;"></i></div>
                        <div class="qa-label">Message History</div>
                        <div class="qa-sub">View all {{ kpi.sentMonth }} messages</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ══ ROW 2: Volume chart + Delivery breakdown ══ -->
          <div class="row mg-b-20">
            <div class="col-xl-8 col-lg-7 mg-b-20">
              <div class="card ht-100p">
                <div class="card-header pd-t-20 pd-b-20">
                  <div>
                    <h6 class="card-title">Messages Sent &amp; Delivered</h6>
                    <p class="card-text">Daily volume for the selected period.</p>
                  </div>
                  <div class="card-option">
                    <ul class="nav nav-tab-line" id="rangeNav">
                      <li class="nav-item"><a href="#" class="nav-link" :class="{ active: chartRange === '7d' }" @click.prevent="setRange('7d')">7D</a></li>
                      <li class="nav-item"><a href="#" class="nav-link" :class="{ active: chartRange === '30d' }" @click.prevent="setRange('30d')">30D</a></li>
                      <li class="nav-item"><a href="#" class="nav-link" :class="{ active: chartRange === '90d' }" @click.prevent="setRange('90d')">3M</a></li>
                    </ul>
                  </div>
                </div>
                <div class="card-body pd-x-20 pd-b-20 pd-t-5">
                  <canvas id="sendChart" height="90"></canvas>
                </div>
                <div class="card-footer pd-x-20 pd-y-15" style="background:#f8f9fc;">
                  <div class="row row-xs text-center">
                    <div class="col-3">
                      <div class="tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-4">Total Sent</div>
                      <div class="tx-semibold tx-20 tx-color-01">{{ totalSent }}</div>
                    </div>
                    <div class="col-3">
                      <div class="tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-4">Delivered</div>
                      <div class="tx-semibold tx-20" style="color:#10b981;">{{ totalDelivered }}</div>
                    </div>
                    <div class="col-3">
                      <div class="tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-4">Pending</div>
                      <div class="tx-semibold tx-20" style="color:#f59e0b;">{{ totalPending }}</div>
                    </div>
                    <div class="col-3">
                      <div class="tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-4">Failed</div>
                      <div class="tx-semibold tx-20" style="color:#ef4444;">{{ totalFailed }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-5 mg-b-20">
              <div class="card ht-100p">
                <div class="card-header pd-t-20 pd-b-20">
                  <div>
                    <h6 class="card-title">Delivery Breakdown</h6>
                    <p class="card-text">Status split for this month.</p>
                  </div>
                </div>
                <div class="card-body pd-20">
                  <div class="d-flex align-items-center mg-b-20" style="gap:20px;">
                    <div class="delivery-ring">
                      <svg width="120" height="120" viewBox="0 0 120 120">
                        <circle cx="60" cy="60" r="50" fill="none" stroke="#e5e9f2" stroke-width="12"/>
                        <circle cx="60" cy="60" r="50" fill="none" stroke="#10b981" stroke-width="12" :stroke-dasharray="deliveredDashArray" stroke-linecap="round"/>
                        <circle cx="60" cy="60" r="50" fill="none" stroke="#ef4444" stroke-width="12" :stroke-dasharray="failedDashArray" :stroke-dashoffset="failedDashOffset" stroke-linecap="round"/>
                        <circle cx="60" cy="60" r="50" fill="none" stroke="#f59e0b" stroke-width="12" :stroke-dasharray="pendingDashArray" :stroke-dashoffset="pendingDashOffset" stroke-linecap="round"/>
                      </svg>
                      <div class="ring-center"><div class="pct">{{ kpi.deliveryRate }}%</div><div class="lbl">delivered</div></div>
                    </div>
                    <div style="flex:1;">
                      <div class="mg-b-10">
                        <div class="d-flex justify-content-between mg-b-2">
                          <span class="tx-12"><span style="width:8px;height:8px;border-radius:50%;background:#10b981;display:inline-block;margin-right:5px;"></span>Delivered</span>
                          <span class="tx-12 tx-semibold">{{ totalDelivered }} <span class="tx-color-04">{{ kpi.deliveryRate }}%</span></span>
                        </div>
                        <div class="ch-bar-track"><div class="ch-bar-fill" :style="{ width: kpi.deliveryRate + '%', background: '#10b981' }"></div></div>
                      </div>
                      <div class="mg-b-10">
                        <div class="d-flex justify-content-between mg-b-2">
                          <span class="tx-12"><span style="width:8px;height:8px;border-radius:50%;background:#f59e0b;display:inline-block;margin-right:5px;"></span>Pending</span>
                          <span class="tx-12 tx-semibold">{{ totalPending }} <span class="tx-color-04">{{ pendingPercent }}%</span></span>
                        </div>
                        <div class="ch-bar-track"><div class="ch-bar-fill" :style="{ width: pendingPercent + '%', background: '#f59e0b' }"></div></div>
                      </div>
                      <div>
                        <div class="d-flex justify-content-between mg-b-2">
                          <span class="tx-12"><span style="width:8px;height:8px;border-radius:50%;background:#ef4444;display:inline-block;margin-right:5px;"></span>Failed</span>
                          <span class="tx-12 tx-semibold">{{ totalFailed }} <span class="tx-color-04">{{ kpi.failRate }}%</span></span>
                        </div>
                        <div class="ch-bar-track"><div class="ch-bar-fill" :style="{ width: kpi.failRate + '%', background: '#ef4444' }"></div></div>
                      </div>
                    </div>
                  </div>
                  <hr style="border-color:#f0f2f7;margin:0 0 14px;">
                  <div class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-10">By Source</div>
                  <div class="pd-y-7 d-flex justify-content-between" style="border-bottom:1px solid #f0f2f7;">
                    <span class="tx-13 tx-color-02">Campaigns</span>
                    <span class="tx-13 tx-semibold">{{ sourceStats.campaigns }} <span class="tx-color-04">{{ sourceStats.campaignsPercent }}%</span></span>
                  </div>
                  <div class="pd-y-7 d-flex justify-content-between" style="border-bottom:1px solid #f0f2f7;">
                    <span class="tx-13 tx-color-02">Manual sends</span>
                    <span class="tx-13 tx-semibold">{{ sourceStats.manual }} <span class="tx-color-04">{{ sourceStats.manualPercent }}%</span></span>
                  </div>
                  <div class="pd-y-7 d-flex justify-content-between">
                    <span class="tx-13 tx-color-02">API triggers</span>
                    <span class="tx-13 tx-semibold">{{ sourceStats.api }} <span class="tx-color-04">{{ sourceStats.apiPercent }}%</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ══ ROW 3: Campaigns + Recent Activity ══ -->
          <div class="row">
            <div class="col-xl-4 col-lg-5 mg-b-20">
              <div class="card ht-100p">
                <div class="card-header pd-t-20 pd-b-20">
                  <div>
                    <h6 class="card-title">Campaigns</h6>
                    <p class="card-text">Current &amp; upcoming sends.</p>
                  </div>
                  <a href="#" class="card-option tx-13 tx-primary" @click.prevent="viewAllCampaigns">View all →</a>
                </div>
                <div class="card-body pd-x-20 pd-t-5 pd-b-10">
                  <div v-for="campaign in campaigns" :key="campaign.name" class="camp-item">
                    <div class="d-flex align-items-center justify-content-between mg-b-4">
                      <div class="tx-13 tx-semibold tx-color-01 text-truncate" style="max-width:175px;">{{ campaign.name }}</div>
                      <span :class="'status-pill ' + campaign.statusClass"><span class="dot"></span>{{ campaign.statusText }}</span>
                    </div>
                    <div class="d-flex justify-content-between tx-12 tx-color-03">
                      <span>{{ campaign.sent }} / {{ campaign.total }} sent</span><span>{{ campaign.percentComplete }}%</span>
                    </div>
                    <div class="camp-prog-track"><div :class="'camp-prog-fill ' + campaign.progressClass" :style="{ width: campaign.percentComplete + '%' }"></div></div>
                    <div class="tx-11 tx-color-04 mg-t-4">{{ campaign.subText }}</div>
                  </div>
                </div>
                <div class="card-footer pd-x-20 pd-y-12" style="background:#f8f9fc;">
                  <a href="#" class="btn btn-sm btn-primary btn-block" @click.prevent="newCampaign">
                    <i class="fas fa-plus mg-r-6" style="font-size:11px;"></i> New Campaign
                  </a>
                </div>
              </div>
            </div>

            <div class="col-xl-8 col-lg-7 mg-b-20">
              <div class="card ht-100p">
                <div class="card-header pd-t-20 pd-b-20">
                  <div>
                    <h6 class="card-title">Recent Activity</h6>
                    <p class="card-text">Latest messages across all sources.</p>
                  </div>
                  <a href="#" class="card-option tx-13 tx-primary" @click.prevent="viewHistory">View full history →</a>
                </div>
                <div class="card-body pd-0">
                  <div class="table-responsive">
                    <table class="table activity-table mg-b-0">
                      <thead>
                      <tr>
                        <th style="padding-left:20px;">Recipient</th>
                        <th>Preview</th>
                        <th>Status</th>
                        <th>Source</th>
                        <th>Time</th>
                        <th style="width:36px;"></th>
                      </tr>
                      </thead>
                      <tbody id="activityBody">
                      <tr v-for="msg in recentMessages" :key="msg.phone" @click="viewMessageDetail(msg)">
                        <td style="padding-left:20px;">
                          <div class="d-flex align-items-center" style="gap:8px;">
                            <div :style="{ width:'30px', height:'30px', borderRadius:'50%', background:msg.color, color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px', fontWeight:'700', flexShrink:'0' }">{{ msg.initials }}</div>
                            <div><div class="tx-13 tx-semibold" style="white-space:nowrap;">{{ msg.name }}</div><div class="tx-11 tx-color-04">{{ msg.phone }}</div></div>
                          </div>
                        </td>
                        <td class="tx-13 tx-color-03" style="max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ msg.preview }}</td>
                        <td v-html="getStatusPill(msg.status)"></td>
                        <td v-html="getSourceBadge(msg.source)"></td>
                        <td class="tx-12 tx-color-04" style="white-space:nowrap;">{{ msg.time }}</td>
                        <td><i class="fas fa-chevron-right" style="font-size:10px;color:#c0ccda;"></i></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer d-flex align-items-center justify-content-between pd-x-20 pd-y-12" style="background:#f8f9fc;">
                  <span class="tx-13 tx-color-03">{{ recentMessages.length }} most recent messages</span>
                  <a href="#" class="btn btn-sm btn-white" @click.prevent="viewHistory">
                    View all <i class="fas fa-arrow-right mg-l-5" style="font-size:11px;"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Toast -->
        <div id="toastEl" :style="toastStyle" v-show="toastVisible">
          <div class="d-flex align-items-center" style="gap:10px;">
            <i :class="'fas ' + toastIcon" :style="{ fontSize:'18px', flexShrink:'0', color: toastColor }"></i>
            <div class="flex-fill">
              <div class="tx-semibold tx-14">{{ toastMessage }}</div>
            </div>
            <button @click="toastVisible = false" style="background:none;border:none;cursor:pointer;color:#8392a5;font-size:18px;padding:0;">&times;</button>
          </div>
        </div>


      </div><!-- container -->

  </div>
</template>

<script>
import Chart from 'chart.js/auto'
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import footerScriptMixin from "@/mixins/footer-script";

export default {
  name: 'SmsDashboard',
  components: {SideBarAsideFix},
  mixins: [footerScriptMixin],
  data() {
    return {
      // Chart
      chartInstance: null,
      chartRange: '30d',
      chartData: {
        '7d': { l: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'], sent: [24,18,32,28,15,8,5], del: [23,18,31,27,15,7,5] },
        '30d': { l: ['Mar 05','Mar 10','Mar 15','Mar 20','Mar 25','Apr 01','Apr 03'], sent: [48,35,62,84,29,46,18], del: [47,34,61,82,28,45,17] },
        '90d': { l: ['Jan','Feb','Mar','Apr'], sent: [320,490,656,312], del: [312,480,640,305] }
      },

      // KPI Data
      kpi: {
        credits: 950,
        creditsUsed: 550,
        creditsUsedPercent: 55,
        sentMonth: 312,
        sentMonthPercent: 62,
        deliveryRate: 97.7,
        failed: 9,
        failRate: 2.3,
        activeCampaigns: 2,
        activeCampaignsSub: '1 sending · 1 scheduled',
        activeCampaignsPercent: 40,
        avgDelivery: 4.2,
        avgDeliveryPercent: 85
      },

      // Totals
      totalSent: 312,
      totalDelivered: 305,
      totalPending: 7,
      totalFailed: 9,

      // Source Stats
      sourceStats: {
        campaigns: 210,
        campaignsPercent: 67,
        manual: 95,
        manualPercent: 30,
        api: 7,
        apiPercent: 2
      },

      // Campaigns
      campaigns: [
        {
          name: 'April promo — spring sale',
          statusText: 'Sending',
          statusClass: 'pill-sending',
          sent: 612,
          total: 840,
          percentComplete: 72.9,
          progressClass: '',
          subText: 'Started 09:00 · Est. complete 09:18'
        },
        {
          name: 'Weekend flash sale',
          statusText: 'Scheduled',
          statusClass: 'pill-scheduled',
          sent: 0,
          total: 520,
          percentComplete: 0,
          progressClass: 'sched',
          subText: 'Sat 06 Apr · 08:00 · 520 credits reserved'
        },
        {
          name: 'March newsletter',
          statusText: 'Completed',
          statusClass: 'pill-delivered',
          sent: 1200,
          total: 1200,
          percentComplete: 100,
          progressClass: 'done',
          subText: 'Delivery rate: 98.1%'
        },
        {
          name: 'Feb flash sale',
          statusText: 'Completed',
          statusClass: 'pill-delivered',
          sent: 620,
          total: 620,
          percentComplete: 100,
          progressClass: 'done',
          subText: 'Delivery rate: 97.4%'
        }
      ],

      // Recent Messages
      recentMessages: [
        { name: 'James Holloway', phone: '+447700900001', initials: 'JH', color: '#0168fa', preview: 'Hi James, your appointment is confirmed…', status: 'DELIVERED', source: 'Manual', time: '10:15' },
        { name: 'Sarah Mitchell', phone: '+447700900002', initials: 'SM', color: '#10b981', preview: 'Hi Sarah, your appointment is confirmed…', status: 'DELIVERED', source: 'Manual', time: '10:15' },
        { name: 'Tom Radcliffe', phone: '+447700900003', initials: 'TR', color: '#f59e0b', preview: 'Hi Tom, your appointment is confirmed…', status: 'FAILED', source: 'Manual', time: '10:15' },
        { name: 'Emily Chen', phone: '+447700900004', initials: 'EC', color: '#8b5cf6', preview: 'Hi Emily, 20% off ends Sunday. Shop now…', status: 'DELIVERED', source: 'Campaign', time: '09:12' },
        { name: 'David Okafor', phone: '+447700900005', initials: 'DO', color: '#ef4444', preview: 'Hi David, 20% off ends Sunday. Shop now…', status: 'DELIVERED', source: 'Campaign', time: '09:12' },
        { name: 'Laura Simmons', phone: '+447700900006', initials: 'LS', color: '#0ea5e9', preview: 'Hi Laura, 20% off ends Sunday. Shop now…', status: 'SENT', source: 'Campaign', time: '09:11' },
        { name: 'Kevin Walsh', phone: '+447700900007', initials: 'KW', color: '#f97316', preview: 'Hi Kevin, 20% off ends Sunday. Shop now…', status: 'DELIVERED', source: 'Campaign', time: '09:10' },
        { name: 'Priya Sharma', phone: '+447700900008', initials: 'PS', color: '#ec4899', preview: 'Your invoice #1042 is ready to view…', status: 'DELIVERED', source: 'Manual', time: '08:44' },
        { name: 'Marcus Brown', phone: '+447700900009', initials: 'MB', color: '#6366f1', preview: 'Welcome to Acme CRM! Your account is…', status: 'QUEUED', source: 'API', time: '08:30' },
        { name: 'Zoe Adeyemi', phone: '+447700900010', initials: 'ZA', color: '#14b8a6', preview: 'Hi Zoe, your March newsletter is here…', status: 'DELIVERED', source: 'Campaign', time: '08:00' }
      ],

      // Toast
      toastVisible: false,
      toastMessage: '',
      toastColor: '#0168fa',
      toastIcon: 'fa-info-circle',
      toastTimeout: null,

      // UI State
      lowBalance: true
    }
  },

  computed: {
    deliveredDashArray() {
      const circumference = 2 * Math.PI * 50
      const deliveredPercent = this.kpi.deliveryRate
      return (circumference * deliveredPercent / 100) + ' ' + circumference
    },
    failedDashArray() {
      const circumference = 2 * Math.PI * 50
      const failedPercent = this.kpi.failRate
      return (circumference * failedPercent / 100) + ' ' + circumference
    },
    failedDashOffset() {
      const circumference = 2 * Math.PI * 50
      const deliveredPercent = this.kpi.deliveryRate
      return - (circumference * deliveredPercent / 100)
    },
    pendingDashArray() {
      const circumference = 2 * Math.PI * 50
      const pendingPercent = this.pendingPercent
      return (circumference * pendingPercent / 100) + ' ' + circumference
    },
    pendingDashOffset() {
      const circumference = 2 * Math.PI * 50
      const deliveredPercent = this.kpi.deliveryRate
      return - (circumference * deliveredPercent / 100)
    },
    pendingPercent() {
      return ((this.totalPending / this.totalSent) * 100).toFixed(1)
    },
    toastStyle() {
      return {
        display: this.toastVisible ? 'block' : 'none',
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        minWidth: '280px',
        background: '#fff',
        borderLeft: `4px solid ${this.toastColor}`,
        borderRadius: '6px',
        boxShadow: '0 8px 30px rgba(0,0,0,.12)',
        padding: '14px 18px',
        animation: 'fadein .3s ease'
      }
    }
  },

  mounted() {
    this.initChart()
    // Replace feather icons
    if (window.feather) {
      window.feather.replace()
    }
  },

  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout)
    }
  },

  created() {
    this.footerScript();
    this.asideBarScript();
  },
  methods: {
    initChart() {
      const ctx = document.getElementById('sendChart').getContext('2d')
      if (this.chartInstance) {
        this.chartInstance.destroy()
      }
      const data = this.chartData[this.chartRange]
      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: data.l,
          datasets: [
            { label: 'Sent', data: data.sent, borderColor: '#0168fa', backgroundColor: 'rgba(1,104,250,.07)', borderWidth: 2, tension: 0.4, fill: true, pointRadius: 3, pointHoverRadius: 5 },
            { label: 'Delivered', data: data.del, borderColor: '#10b981', backgroundColor: 'rgba(16,185,129,.05)', borderWidth: 2, tension: 0.4, fill: true, pointRadius: 3, pointHoverRadius: 5 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: { position: 'top', align: 'end', labels: { usePointStyle: true, pointStyleWidth: 8, font: { size: 11 }, color: '#596882', boxHeight: 6 } },
            tooltip: { callbacks: { label: (c) => ' ' + c.dataset.label + ': ' + c.parsed.y + ' msgs' } }
          },
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 11 }, color: '#8392a5' } },
            y: { grid: { color: '#f0f2f7' }, ticks: { font: { size: 11 }, color: '#8392a5', maxTicksLimit: 5 }, beginAtZero: true }
          }
        }
      })
    },

    setRange(range) {
      this.chartRange = range
      this.initChart()
    },

    getStatusPill(status) {
      const pills = {
        DELIVERED: '<span class="status-pill pill-delivered"><span class="dot"></span>Delivered</span>',
        SENT: '<span class="status-pill pill-sent"><span class="dot"></span>Sent</span>',
        QUEUED: '<span class="status-pill pill-queued"><span class="dot"></span>Queued</span>',
        FAILED: '<span class="status-pill pill-failed"><span class="dot"></span>Failed</span>'
      }
      return pills[status] || status
    },

    getSourceBadge(source) {
      const badges = {
        Manual: '<span class="badge badge-light tx-11">Manual</span>',
        Campaign: '<span class="badge tx-11" style="background:#eef3ff;color:#0168fa;">Campaign</span>',
        API: '<span class="badge badge-secondary tx-11">API</span>'
      }
      return badges[source] || source
    },

    showToast(message, color = '#0168fa', icon = 'fa-info-circle') {
      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout)
      }
      this.toastMessage = message
      this.toastColor = color
      this.toastIcon = icon
      this.toastVisible = true
      this.toastTimeout = setTimeout(() => {
        this.toastVisible = false
      }, 3500)
    },

    doRefresh() {
      this.showToast('Data refreshed successfully.', '#10b981', 'fa-check-circle')
    },

    doExport() {
      this.showToast('Dashboard exported to CSV.', '#0168fa', 'fa-download')
    },

    newCampaign() {
      this.showToast('Campaign builder opening…', '#7c3aed', 'fa-bullhorn')
    },

    viewHistory() {
      this.showToast('Viewing full message history...', '#0168fa', 'fa-history')
    },

    viewAllCampaigns() {
      this.showToast('Viewing all campaigns...', '#0168fa', 'fa-bullhorn')
    },

    viewMessageDetail(message) {
      this.showToast(`Viewing details for ${message.name}`, '#0168fa', 'fa-envelope')
    }
  }
}
</script>

<style scoped>
body { background-color: #f4f5f8; }

/* ── Hero Panel ─────────────────────────────────────── */
.sms-hero {
  background: linear-gradient(135deg, #1a3faa 0%, #0168fa 55%, #2196f3 100%);
  padding: 28px 30px 0;
  position: relative;
  overflow: hidden;
}
.sms-hero::before {
  content: '';
  position: absolute;
  top: -60px; right: -80px;
  width: 340px; height: 340px;
  border-radius: 50%;
  background: rgba(255,255,255,.06);
  pointer-events: none;
}
.sms-hero::after {
  content: '';
  position: absolute;
  bottom: 20px; left: -40px;
  width: 200px; height: 200px;
  border-radius: 50%;
  background: rgba(255,255,255,.04);
  pointer-events: none;
}
.hero-breadcrumb .breadcrumb { background: transparent; padding: 0; margin-bottom: 6px; }
.hero-breadcrumb .breadcrumb-item,
.hero-breadcrumb .breadcrumb-item a,
.hero-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: rgba(255,255,255,.65); font-size: 12px; }
.hero-breadcrumb .breadcrumb-item.active { color: rgba(255,255,255,.9); }
.hero-title { color: #fff; font-size: 22px; font-weight: 700; margin: 0; letter-spacing: -.3px; }
.hero-actions { display: flex; align-items: center; gap: 8px; }
.hero-actions .btn-hero-outline {
  background: rgba(255,255,255,.15);
  border: 1px solid rgba(255,255,255,.3);
  color: #fff;
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em;
  padding: 6px 14px; border-radius: 4px; cursor: pointer; transition: background .15s;
}
.hero-actions .btn-hero-outline:hover { background: rgba(255,255,255,.25); }
.hero-actions .btn-hero-primary {
  background: #fff;
  border: none;
  color: #0168fa;
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em;
  padding: 6px 14px; border-radius: 4px; cursor: pointer; transition: box-shadow .15s;
  text-decoration: none; display: inline-flex; align-items: center; gap: 5px;
}
.hero-actions .btn-hero-primary:hover { box-shadow: 0 4px 14px rgba(0,0,0,.2); color: #0168fa; text-decoration: none; }

/* Hero KPI strip */
.hero-kpi-strip {
  display: flex;
  gap: 0;
  margin-top: 24px;
  border-top: 1px solid rgba(255,255,255,.15);
}
.hero-kpi-item {
  flex: 1;
  padding: 18px 20px 16px;
  border-right: 1px solid rgba(255,255,255,.12);
  position: relative;
}
.hero-kpi-item:last-child { border-right: none; }
.hero-kpi-label {
  font-size: 10px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .08em; color: rgba(255,255,255,.65); margin-bottom: 6px;
}
.hero-kpi-value {
  font-size: 26px; font-weight: 700; color: #fff; line-height: 1; margin-bottom: 4px;
}
.hero-kpi-sub { font-size: 11px; color: rgba(255,255,255,.6); }
.hero-kpi-badge {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 10px; font-weight: 600;
  padding: 2px 7px; border-radius: 20px; margin-top: 5px;
}
.hbadge-up   { background: rgba(16,185,129,.25); color: #6ee7b7; }
.hbadge-down { background: rgba(239,68,68,.25);  color: #fca5a5; }
.hbadge-neu  { background: rgba(255,255,255,.15); color: rgba(255,255,255,.8); }
.hero-kpi-bar-track {
  height: 3px; background: rgba(255,255,255,.2); border-radius: 2px;
  overflow: hidden; margin-top: 8px;
}
.hero-kpi-bar-fill { height: 100%; border-radius: 2px; background: rgba(255,255,255,.7); }

/* Low balance banner */
.low-bal-banner { background:#fffbeb; border:1px solid #fde68a; border-radius:8px; padding:12px 18px; margin-bottom:20px; display:none; align-items:center; gap:12px; font-size:13px; color:#92400e; }
.low-bal-banner.show { display:flex; }

/* ── Content area ─────────────────────────────────── */
.content-body { padding: 24px 28px; max-width: 1280px; margin: 0 auto; }

/* Quick action tiles */
.quick-action { background:#fff; border:1px solid #e5e9f2; border-radius:8px; padding:18px 16px; text-align:center; cursor:pointer; transition:box-shadow .15s,border-color .15s,transform .1s; text-decoration:none; display:block; color:#1c273c; height:100%; }
.quick-action:hover { box-shadow:0 4px 16px rgba(1,104,250,.12); border-color:#0168fa; color:#0168fa; text-decoration:none; transform:translateY(-2px); }
.qa-icon  { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:20px; margin:0 auto 12px; }
.qa-label { font-size:13px; font-weight:600; }
.qa-sub   { font-size:11px; color:#8392a5; margin-top:3px; }

/* Status pills */
.status-pill { display:inline-flex; align-items:center; gap:5px; font-size:11px; font-weight:600; padding:3px 9px; border-radius:20px; white-space:nowrap; }
.status-pill .dot { width:6px; height:6px; border-radius:50%; flex-shrink:0; }
.pill-delivered { background:#e6f9f2; color:#0d7a52; } .pill-delivered .dot { background:#10b981; }
.pill-sent      { background:#eef3ff; color:#2155b4; } .pill-sent .dot      { background:#4f83e2; }
.pill-queued    { background:#fefce8; color:#92400e; } .pill-queued .dot    { background:#f59e0b; }
.pill-failed    { background:#fef2f2; color:#b91c1c; } .pill-failed .dot    { background:#ef4444; }
.pill-scheduled { background:#f3f0ff; color:#5b21b6; } .pill-scheduled .dot { background:#7c3aed; }
.pill-sending   { background:#eff6ff; color:#1d4ed8; } .pill-sending .dot   { background:#3b82f6; animation:blink 1s infinite; }
@keyframes blink { 0%,100%{opacity:1;} 50%{opacity:.3;} }

/* Activity table */
.activity-table thead th { font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.05em; color:#8392a5; border-bottom:1px solid #e5e9f2; padding:9px 14px; white-space:nowrap; }
.activity-table td        { padding:11px 14px; vertical-align:middle; border-top:1px solid #f0f2f7; font-size:13px; color:#1c273c; }
.activity-table tbody tr  { cursor:pointer; transition:background .1s; }
.activity-table tbody tr:hover td { background:#f8f9fc; }

/* Campaign progress items */
.camp-item { padding:13px 0; border-bottom:1px solid #f0f2f7; }
.camp-item:last-child { border-bottom:none; }
.camp-prog-track { height:5px; background:#e5e9f2; border-radius:3px; overflow:hidden; margin-top:7px; }
.camp-prog-fill  { height:100%; border-radius:3px; background:linear-gradient(90deg,#0168fa,#4f9cff); transition:width .6s; }
.camp-prog-fill.done  { background:#10b981; }
.camp-prog-fill.sched { background:#7c3aed; }

/* SVG ring chart */
.delivery-ring { position:relative; width:120px; height:120px; flex-shrink:0; }
.delivery-ring svg { transform:rotate(-90deg); }
.ring-center { position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; }
.ring-center .pct { font-size:22px; font-weight:700; color:#1c273c; line-height:1; }
.ring-center .lbl { font-size:10px; color:#8392a5; margin-top:2px; }

/* Channel bars */
.ch-bar-track { height:6px; background:#e5e9f2; border-radius:3px; overflow:hidden; margin-top:5px; }
.ch-bar-fill  { height:100%; border-radius:3px; }

/* Hero responsive */
@media (max-width: 767px) {
  .hero-kpi-item { padding: 14px 12px; }
  .hero-kpi-value { font-size: 20px; }
  .sms-hero { padding: 20px 16px 0; }
  .content-body { padding: 16px; }
}
@media (max-width: 575px) {
  .hero-kpi-strip { flex-wrap: wrap; }
  .hero-kpi-item { flex: 0 0 50%; border-bottom: 1px solid rgba(255,255,255,.12); }
}

@keyframes fadein {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: none; }
}
</style>


<!--<template>-->
<!--  <SideBarAsideFix/>-->

<!--  <div class="content pd-0" style="border: 1px solid #ccc;">-->
<!--    <div class="content-header">-->
<!--      <div class="content-search">-->
<!--        <i data-feather="search"></i>-->
<!--        <input type="search" class="form-control" placeholder="Search...">-->
<!--      </div>-->
<!--      <nav class="nav">-->
<!--        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>-->
<!--        <a href="" class="nav-link"><i data-feather="grid"></i></a>-->
<!--        <a href="" class="nav-link"><i data-feather="align-left"></i></a>-->
<!--      </nav>-->
<!--    </div>&lt;!&ndash; content-header &ndash;&gt;-->

<!--    <div class="content-body">-->




<!--    </div>&lt;!&ndash; container &ndash;&gt;-->

<!--  </div>-->
<!--</template>-->



<!--import footerScriptMixin from "@/mixins/footer-script";-->
<!--created() {-->
<!--this.footerScript();-->
<!--this.asideBarScript();-->
<!--},-->
